import { useState } from "react";
import cx from "classnames";

import TextBox from "../TextBox";

import styles from "./AmountInputWithCurrency.module.scss";

const AmountInputWithCurrency = ({
  amount = 0,
  className,
  handleChange,
  currency,
  id,
  name,
  isLoading = false,
  maxDecimalCharaters = 10,
}) => {
  const [isFocus, setIsFocus] = useState(false);

  const onFocus = (val) => {
    setIsFocus(val);
  };

  return (
    <div
      className={cx(
        styles.TextBox,
        className,
        isLoading ? styles.TextBoxLoading : null,
      )}>
      <TextBox
        id={id}
        name={name}
        handleChange={handleChange}
        isLoading={isLoading}
        value={amount}
        type="number"
        required
        maxLength="8"
        max={99999999}
        maxDecimalCharaters={maxDecimalCharaters}
        onFocus={onFocus}
      />
      <div className={cx(styles.InsideInput, isFocus ? styles.Focused : null)}>
        <span>{currency}</span>
      </div>
    </div>
  );
};

export default AmountInputWithCurrency;
